/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IBreadcrumbStyles } from '@fluentui/react/lib/Breadcrumb';
import { IStackStyles, IStackTokens } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';

export const getStackStyles = (theme: ITheme): Partial<IStackStyles> => {
    return {
        root: {
            borderColor: theme.palette.neutralTertiaryAlt,
            borderStyle: 'solid',
            borderTopWidth: 0,
            borderRightWidth: 0,
            borderBottomWidth: '1px',
            borderLeftWidth: 0,
            justifyContent: 'space-between',
            paddingLeft: '1.125rem',
            paddingRight: '1.25rem',
            paddingTop: '0.25rem',
            paddingBottom: '0.25rem',
        },
    };
};

export const getBreadcrumbStyles = (theme: ITheme): Partial<IBreadcrumbStyles> => {
    return {
        root: {
            selectors: {
                '.ms-Breadcrumb-item': {
                    color: theme.palette.black + ' !important',
                },
            },
            margin: 0,
            paddingLeft: 0,
        },
        itemLink: {
            color: theme.palette.black,
        },
    };
};

export const getStackTokens = (): Partial<IStackTokens> => {
    return { childrenGap: '1rem' };
};
